import api from './api';
import { Vendor } from '@/types/vendor';

export interface VendorProfileUpdatePayload {
    firstName: string;
    lastName: string;
    phone: string;
    fullAddress: string;
    province: string;
    district: string;
    neighborhood: string;
    postalCode?: string;
    businessType: string;
    companyName?: string;
    taxOffice: string;
    taxNumber: string;
    bankName: string;
    iban: string;
    accountHolderName: string;
    logoUrl?: string;
    description?: string;
    website?: string;
    password?: string;
}

export const vendorProfileApi = {
    async getProfile(): Promise<Vendor> {
        try {
            const response = await api.get('/vendor/profile');
            return response.data;
        } catch (error: any) {
            console.error('Error fetching vendor profile:', error);
            throw new Error(error.response?.data?.error || 'Profil yüklenemedi');
        }
    },

    async updateProfile(payload: VendorProfileUpdatePayload): Promise<Vendor> {
        try {
            const response = await api.put('/vendor/profile', payload);
            return response.data;
        } catch (error: any) {
            console.error('Error updating vendor profile:', error);
            throw new Error(error.response?.data?.error || 'Profil güncellenemedi');
        }
    },
};